export const stockRequestFormHandler = (form?: HTMLFormElement, onSuccess?: () => void) => {
  const bind = () => {
    const stockForm = form ?? document.getElementById('stockRequestForm') as HTMLFormElement;
    if (!stockForm || stockForm.dataset.bound === 'true') return;
    stockForm.dataset.bound = 'true';

    stockForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const message = stockForm.querySelector('#stockRequestMessage') as HTMLElement,
        emailEle = stockForm.querySelector('[name=email]') as HTMLInputElement,
        productIdEle = stockForm.querySelector('[name=ProductId]') as HTMLInputElement,
        email = emailEle ? emailEle.value : "",
        productId = productIdEle ? productIdEle.value : "",
        submitBtn = stockForm.querySelector<HTMLButtonElement>('.btn');

      submitBtn.classList.add('disabled');

      let variationId = "";

      const variations = stockForm.querySelectorAll('.stock-variation-input');
      variations?.forEach(variation => {
        variationId = variationId + (variation as HTMLInputElement).value + ",";
      });

      let url;

      if (variationId) url = `/product/product/SaveStockRequest?&email=${email}&subscribed=false&productId=${productId}&variationId=${variationId}`;
      else url = `/product/product/SaveStockRequest?&email=${email}&subscribed=false&productId=${productId}`;

      fetch(url, {
        method: 'POST'
      }).then(r => {
        return r.json();
      }).then(data => {
        message.innerText = data.message;
        if (data.success) {
          message.classList.add('alert-success');
          message.classList.remove('alert-danger');
          onSuccess?.();
        } else {
          message.classList.add('alert-danger');
          message.classList.remove('alert-success');
        }
        message.classList.remove('hidden');
        submitBtn.classList.remove('disabled');
      });
    });
  };

  if (form) bind();
  else setTimeout(bind, 500);
};